module.exports = __webpack_public_path__ + "img/shfl.64a6082d.png";